var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "follow-btn-component FollowBtn" }, [
    _c(
      "button",
      {
        staticClass: "btn btn__round btn__bordered",
        class: { active: _vm.user.is_following },
        attrs: { disabled: _vm.loading },
        on: {
          click: _vm.follow,
          mouseover: function($event) {
            _vm.mouseover = true
          },
          mouseleave: function($event) {
            _vm.mouseover = false
          }
        }
      },
      [
        _vm.loading
          ? _c("div", { staticClass: "spinner-border" })
          : !_vm.user.is_following
          ? _c("i", { staticClass: "icon-follow" }, [
              _c("span", { staticClass: "path1" }),
              _c("span", { staticClass: "path2" }),
              _c("span", { staticClass: "path3" }),
              _c("span", { staticClass: "path4" }),
              _c("span", { staticClass: "path5" }),
              _c("span", { staticClass: "path6" }),
              _c("span", { staticClass: "path7" }),
              _c("span", { staticClass: "path8" })
            ])
          : !_vm.mouseover
          ? _c("img", {
              attrs: { src: require("@assets/imgs/follow-confirmed.svg") }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.btnText))])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }